// extracted by mini-css-extract-plugin
export default {"title":"title-iqLyAP","text":"text-qSEykZ","icon":"icon-CrxdwF"};